import {
  CommentRangeEnd,
  CommentRangeStart,
  CommentReference,
  Document,
  ImageRun,
  Packer,
  Paragraph,
  TextRun,
} from "docx";

const listComments = (l) => {
  const dicos = l.children
    .filter((t) => t.dico !== undefined)
    .map((t) => {
      // console.log("Should dico coms :", t.dico);
      return {
        id: t.dico.id,
        author: "Nabook",
        date: new Date(),
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: t.dico.definition,
              }),
            ],
          }),
        ],
      };
    });

  const deletes = l.children
    .filter((t) => t.delete !== undefined)
    .map((t) => {
      // console.log("Should delete coms :", t.delete);
      return {
        id: t.delete.id,
        author: "Nabook",
        date: new Date(),
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: "À supprimer",
              }),
            ],
          }),
        ],
      };
    });

  return [...dicos, ...deletes];
};

const addComments = (textRun, dico, shouldDelete) => {
  if (!dico && !shouldDelete) return [textRun];

  const arrayToReturn = [textRun];

  if (shouldDelete) {
    arrayToReturn.splice(0, 0, new CommentRangeStart(shouldDelete.id));
    arrayToReturn.push(
      new CommentRangeEnd(shouldDelete.id),
      new TextRun({
        children: [new CommentReference(shouldDelete.id)],
      })
    );
  }

  if (dico) {
    arrayToReturn.splice(0, 0, new CommentRangeStart(dico.id));
    arrayToReturn.push(
      new CommentRangeEnd(dico.id),
      new TextRun({
        children: [new CommentReference(dico.id)],
      })
    );
  }

  return arrayToReturn;
};

const createText = (t) => {
  return addComments(
    new TextRun({
      text: t.text,
      ...(t.bold && { bold: true }),
      ...(t.italic && { italics: true }),
      ...(t.delete && { strike: true }),
      ...(t.dico && { underline: {} }),
    }),
    t.dico,
    t.delete
  );
};

const createImg = async (i) => {
  console.log(i);
  return new Promise(async (resolve, reject) => {
    if (!i.url || i.url.length <= 0) resolve(createText({ text: `` }));
    try {
      const file = await fetch(i.url, {
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "image/jpeg",
        },
      });

      const img = new Image();
      img.src = i.url;

      img.onload = async () => {
        const w = img.width > 500 ? 500 : img.width;
        const aspectRatio = img.width / img.height;

        resolve([
          new ImageRun({
            data: await file.arrayBuffer(),
            transformation: {
              width: w,
              height: w / aspectRatio,
            },
          }),
        ]);
      };
    } catch (e) {
      console.log(e);
      resolve(createText({ text: `[[${i.url}]]` }));
    }
  });
};

const createParagraph = async (l) => {
  if (l.type === "image")
    return new Paragraph({
      children: await createImg(l),
    });

  const isNarrateur = l.speaker && l.speaker.name === "Narrateur";

  const text = l.children.reduce((acc, t) => [...acc, ...createText(t)], []);

  if (!isNarrateur) text.push(...createText({ text: ` (${l.speaker.name})` }));

  return new Paragraph({
    children: text,
    ...(!isNarrateur && {
      bullet: {
        level: 0,
      },
    }),
  });
};

const toDocx = async (jsonData, fileName, resume = null) => {
  const paragraphs = [];

  if (resume)
    paragraphs.push(
      new Paragraph({
        children: createText({
          italic: true,
          text: "Résumé : " + resume + "\n\n---------------\n\n",
        }),
      })
    );

  for (const l of jsonData.lines) paragraphs.push(await createParagraph(l));

  const doc = new Document({
    comments: {
      children: jsonData.lines
        .map((l) => listComments(l))
        .reduce((acc, l) => [...acc, ...l], []),
    },
    sections: [
      {
        properties: {},
        children: paragraphs,
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = fileName;
    link.href = url;
    link.click();
  });
};

export { toDocx };
